import React from 'react'
import { useGeneral } from '../../context/general'
import useUser from '../../hooks/useUser'
import TabHeader from './TabHeader'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Skeleton, IconButton } from '@mui/material'

const APIToken = () => {
    const { setPopupAlert } = useGeneral()
    const { user } = useUser()

    const copyKey = () => {
        navigator.clipboard.writeText(user.api_key)
        setPopupAlert('success', 'Copied!')
    }

    const renderApiKey = () => (
        <>
            <span>{user.api_key}</span>
            <IconButton onClick={copyKey} size="small">
                <ContentCopyIcon fontSize="inherit"/>
            </IconButton>
        </>
    )

    return (
        <>
            <TabHeader header='API Token'/>
            {user ? renderApiKey() : <Skeleton width={300}/>}
        </>
    )  
}

export default APIToken